/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// `_grecaptcha`: Google writes to localStorage; keep it in sessionStorage instead
{
  const key = '_grecaptcha';
  const { setItem, getItem, removeItem } = Storage.prototype;
  const legacy = getItem.call(localStorage, key);
  if (legacy != null) {
    setItem.call(sessionStorage, key, legacy);
    removeItem.call(localStorage, key);
  }
  Storage.prototype.setItem = function (k: string, v: string) {
    if (k === key && this === localStorage) {
      setItem.call(sessionStorage, k, v);
      removeItem.call(localStorage, k);
      return;
    }
    setItem.call(this, k, v);
  };
  Storage.prototype.getItem = function (k: string) {
    return k === key && this === localStorage ? getItem.call(sessionStorage, k) : getItem.call(this, k);
  };
  Storage.prototype.removeItem = function (k: string) {
    if (k === key && this === localStorage) {
      removeItem.call(sessionStorage, k);
      removeItem.call(localStorage, k);
      return;
    }
    removeItem.call(this, k);
  };
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
